export const OFFER_DETAILS_QR_CODE_SIZE = 200;
export const OFFER_DETAILS_MEDIA_IMAGE_SIZE = 72;
export const OFFER_DETAILS_QR_PADDING = 1.5; // Maps to 12px (8 * 1.5)
